<template>
  <div class="chart-container-inner">
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import { 
  Chart as ChartJS, Title, Tooltip, Legend, LineElement, 
  CategoryScale, LinearScale, PointElement, Filler 
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Filler)

export default {
  name: 'LineChartFinance',
  components: { Line },
  
  // 1. Recebe os dados processados lá do Laravel (via dashboard-index)
  props: {
      apiData: {
          type: Object,
          required: true
      }
  },

  // 2. Monta os dados dinamicamente assim que a API responde
  computed: {
      chartData() {
          return {
              labels: this.apiData.labels, // Ex: ['01/03', '02/03', '03/03'...]
              datasets: [
                  {
                      label: 'Entradas',
                      borderColor: '#10b981',
                      backgroundColor: 'rgba(16, 185, 129, 0.15)',
                      borderWidth: 3,
                      pointRadius: 0,
                      pointHoverRadius: 6,
                      pointBackgroundColor: '#fff',
                      pointBorderColor: '#10b981',
                      pointBorderWidth: 2,
                      data: this.apiData.incomes, // Valores diários de Receita
                      fill: true,
                      tension: 0.4
                  },
                  {
                      label: 'Saídas',
                      borderColor: '#f43f5e',
                      backgroundColor: 'rgba(244, 63, 94, 0.05)',
                      borderWidth: 3,
                      borderDash: [6, 6],
                      pointRadius: 0,
                      pointHoverRadius: 6,
                      pointBackgroundColor: '#fff',
                      pointBorderColor: '#f43f5e',
                      pointBorderWidth: 2,
                      data: this.apiData.expenses, // Valores diários de Despesa
                      fill: true,
                      tension: 0.4
                  }
              ]
          }
      }
  },

  // 3. Opções visuais do gráfico
  data() {
      return {
          chartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              interaction: { 
                  mode: 'index', 
                  intersect: false 
              },
              plugins: { 
                  legend: { 
                      position: 'top', 
                      align: 'end', 
                      labels: { usePointStyle: true, boxWidth: 8 } 
                  },
                  tooltip: {
                      backgroundColor: 'rgba(30, 41, 59, 0.9)',
                      padding: 12,
                      cornerRadius: 8,
                      callbacks: {
                          label: function(context) {
                              let label = context.dataset.label || '';
                              if (label) { label += ': '; }
                              if (context.parsed.y !== null) {
                                  label += new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(context.parsed.y);
                              }
                              return label;
                          }
                      }
                  }
              },
              scales: {
                  x: { 
                      grid: { display: false, drawBorder: false },
                      ticks: { color: '#94a3b8', font: { size: 11 } }
                  },
                  y: { 
                      border: { display: false }, 
                      grid: { color: '#f1f5f9' }, 
                      ticks: { 
                          color: '#94a3b8',
                          padding: 10,
                          callback: function(value) {
                              if (value >= 1000) return (value / 1000).toFixed(1).replace('.0', '') + 'k';
                              return value;
                          }
                      } 
                  }
              }
          }
      }
  }
}
</script>

<style scoped>
.chart-container-inner {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>